module.exports = __webpack_public_path__ + "img/box3_img2_active.25bd18eb.png";